<div class="footer">
  <div class="footer__link">
    <a class="footer__link-item" [href]="sacoda">Sacoda Serv Ltd.</a>
    <a class="footer__link-item" [href]="sacodaAbout">About Us</a>
  </div>
  <div class="footer__icon">
    <button mat-mini-fab>
      <mat-icon fontSet="fa fa-fs" fontIcon="fa-facebook-square"></mat-icon>
    </button>
    <button mat-mini-fab>
      <mat-icon fontSet="fa fa-fs" fontIcon="fa-twitter-square"></mat-icon>
    </button>
    <button mat-mini-fab>
      <mat-icon fontSet="fa fa-fs" fontIcon="fa-instagram-square"></mat-icon>
    </button>
  </div>
</div>
